import { CustomerTypes } from "@faire/help-center-utils/enums/CustomerType";
import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailerToken } from "@faire/help-center-utils/serialized-data/getRetailer";
import { Button } from "@faire/web--source/slate/Button";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackHelpCenterCommonTopicsClick } from "@faire/web-api--source/events/helpCenter/click/commonTopics";
import articlePage from "@faire/web-api--source/routes/www/support/articles/articleId";
import React, { type JSX } from "react";

import { EndWithComma } from "./CommonTopics";

export const RetailerTopics: React.FC = () => {
  const articles = useArticles();
  return (
    <Typography>
      <StrictLocalMsg
        defaultMessage="Common topics: <GuideLinesLinkFormatting>guidelines for selling</GuideLinesLinkFormatting>  <NetTermsLinkFormatting>net 60 terms</NetTermsLinkFormatting>  <ContactABrandLinkFormatting>contacting a brand</ContactABrandLinkFormatting>"
        description={{
          text: "Common topics in the help center",
          img: "https://cdn.faire.com/fastly/d498b624bffa40b5c692e2ed97b5afd379deac1fc8ee290d3c3299096195ccc6.png",
        }}
        values={{
          GuideLinesLinkFormatting: LinkFormatting(
            articlePage(
              `${articles.MyOrders.HOW_SHOULD_I_BE_SELLING_MY_FAIRE_PRODUCT.id}`
            )
          ),
          NetTermsLinkFormatting: LinkFormatting(
            articlePage(`${articles.PaymentsAndInvoices.NET_60_TERMS.id}`)
          ),
          ContactABrandLinkFormatting: LinkFormatting(
            articlePage(`${articles.MyOrders.CONTACT_A_BRAND.id}`)
          ),
        }}
      />
    </Typography>
  );
};

const LinkFormatting = (linkTo: string) =>
  function (chunks: JSX.Element) {
    const retailerToken = getRetailerToken() ?? "";
    const brandToken = getBrandToken() ?? "";

    return (
      <EndWithComma>
        <Button
          linkTo={linkTo}
          variant="tertiary"
          onClick={() =>
            trackHelpCenterCommonTopicsClick(
              retailerToken,
              brandToken,
              CustomerTypes.RETAILER,
              `${chunks}`,
              linkTo
            )
          }
        >
          {chunks}
        </Button>
      </EndWithComma>
    );
  };
